"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.documentAccessControlEntrySchema = void 0;
exports.documentAccessControlEntrySchema = {
    type: 'object',
    additionalProperties: {
        not: true,
        errorMessage: '- should not have additional property ${0#}',
    },
    required: [
        'authorUserControlEntryID',
        'internalUserControlEntryID',
        'externalUserControlEntryID',
        'masterUserControlEntryID',
    ],
    properties: {
        authorUserControlEntryID: {
            type: 'string',
            format: 'uuid',
            errorMessage: 'Should follow UUID format 00000000-0000-0000-0000-000000000000',
        },
        internalUserControlEntryID: {
            type: 'string',
            format: 'uuid',
            errorMessage: 'Should follow UUID format 00000000-0000-0000-0000-000000000000',
        },
        externalUserControlEntryID: {
            type: 'string',
            format: 'uuid',
            errorMessage: 'Should follow UUID format 00000000-0000-0000-0000-000000000000',
        },
        masterUserControlEntryID: {
            type: 'string',
            format: 'uuid',
            errorMessage: 'Should follow UUID format 00000000-0000-0000-0000-000000000000',
        },
    },
};
